import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const NAMES = ['Martín', 'Carolina', 'Jorge', 'Lucía', 'Fernando', 'Sofía', 'Pablo', 'Valentina', 'Facundo', 'Camila'];
const CITIES = ['Tandil', 'Rafaela', 'Entre Ríos', 'Río Cuarto', 'Pergamino', 'Venado Tuerto', 'Balcarce', 'Chivilcoy', 'Olavarría'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)]
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initial = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      setTimeout(showPopup, Math.random() * 5000 + 10000);
    }, 15000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-186">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-3 left-3 z-50 bg-[#0F2E23] border-2 border-[#D4A843] rounded shadow-xl p-1.5 max-w-[220px] flex items-center gap-1.5" data-id="element-187">
          <div className="bg-[#102A1F] p-1 rounded-full flex-shrink-0 border border-[#74C69D]/30" data-id="element-188">
            <ShoppingBagIcon className="w-3 h-3 text-[#74C69D]" data-id="element-189" />
          </div>
          <div data-id="element-190">
            <p className="text-[9px] font-black text-[#FFFFFF] uppercase leading-none mb-0.5" data-id="element-191">
              {data.name} de {data.city}
            </p>
            <p className="text-[7px] text-[#D4A843] font-bold uppercase tracking-wide leading-none mb-0.5" data-id="element-192">
              acaba de comprar el Kit de Educación Ambiental Rural
            </p>
            <p className="text-[6px] text-[#BFC9C5] font-bold uppercase leading-none" data-id="element-193">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}